import { Email, Instagram } from '@mui/icons-material';
import { Box, Container, Divider, IconButton, Link as MuiLink, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { motion } from 'framer-motion';
import { Link } from 'react-router';

const COLUMNAS = [
  {
    titulo: 'Empresa',
    enlaces: [
      { nombre: 'Sobre Nosotros', a: '/sobre-nosotros' },
      { nombre: 'Términos y Condiciones', a: '/terminos' },
      { nombre: 'Política de Privacidad', a: '/privacidad' },
    ],
  },
  {
    titulo: 'Productos',
    enlaces: [{ nombre: 'Catálogo', a: '/catalogo' }],
  },
];

export function PieDePagina() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#0a0a0a',
        color: 'rgba(255, 255, 255, 0.7)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        pt: 8,
        pb: 4,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <Typography
                variant="h6"
                component="p"
                color="white"
                gutterBottom
                sx={{ fontWeight: 700 }}
              >
                CKING
              </Typography>

              <Typography variant="body2" sx={{ mb: 3 }}>
                Importadora y distribuidora de repuestos y accesorios para motocicletas de las
                mejores marcas a nivel mundial.
              </Typography>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email fontSize="small" />
                <Typography variant="body2">info@cking.com.ar</Typography>
              </Box>
            </motion.div>
          </Grid>

          {COLUMNAS.map((columna, indice) => (
            <Grid key={columna.titulo}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 * (indice + 1) }}
              >
                <Typography
                  variant="h6"
                  component="p"
                  color="white"
                  gutterBottom
                  sx={{ fontWeight: 600 }}
                >
                  {columna.titulo}
                </Typography>

                <Box component="nav" aria-label={columna.titulo}>
                  <Box component="ul" sx={{ p: 0, m: 0, listStyle: 'none' }}>
                    {columna.enlaces.map(enlace => (
                      <Box component="li" key={enlace.nombre} sx={{ mb: 1 }}>
                        <MuiLink
                          component={Link}
                          to={enlace.a}
                          sx={{
                            color: 'inherit',
                            textDecoration: 'none',
                            transition: 'color 0.2s',
                            '&:hover': { color: 'primary.main' },
                          }}
                        >
                          {enlace.nombre}
                        </MuiLink>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}

          <Grid>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <Typography
                variant="h6"
                component="p"
                color="white"
                gutterBottom
                sx={{ fontWeight: 600 }}
              >
                Síguenos
              </Typography>

              <Box sx={{ display: 'flex', gap: 1 }}>
                <IconButton
                  component="a"
                  href="https://www.instagram.com/hada.ok/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Seguinos en Instagram (se abre en nueva pestaña)"
                  sx={{ color: 'white', '&:hover': { color: 'primary.main' } }}
                >
                  <Instagram />
                </IconButton>
              </Box>
            </motion.div>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="body2" sx={{ mb: { xs: 2, sm: 0 } }}>
            © {new Date().getFullYear()} CKING. Todos los derechos reservados.
          </Typography>

          <Box sx={{ display: 'flex', gap: 3 }}>
            <MuiLink
              component={Link}
              to="/terminos"
              sx={{
                color: 'inherit',
                textDecoration: 'none',
                '&:hover': { color: 'primary.main' },
              }}
            >
              Términos y Condiciones
            </MuiLink>

            <MuiLink
              component={Link}
              to="/privacidad"
              sx={{
                color: 'inherit',
                textDecoration: 'none',
                '&:hover': { color: 'primary.main' },
              }}
            >
              Política de Privacidad
            </MuiLink>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
